import { Maybe } from '@aibees/shared/definition';
import { cleanUrl } from '@aibees/shared/utils';

export function sanitizeLinkedinUrl(value: Maybe<string>): Maybe<string> {
  if (!value) return value;
  return cleanUrl(value);
}

export function getPathWithId(path: string, id: Maybe<string>) {
  if (id) return path.replace(':id', id);
  return '#';
}
